<template>
    <div class="import_template">
        <el-upload 
            action="javascript:;" 
            :http-request="httpRequestHandler"
            :before-upload="handleBeforeUpload"
            :on-remove="handleRemove">
            <div class="">
                <el-button type="default"><i style="font-size:18px;" class="fa fa-cloud-upload el-button--text" aria-hidden="true"></i>&nbsp;&nbsp;上传文件</el-button>
                </em>
            </div>
        </el-upload>
        <div class="wrapper">
            <div style="text-align:center;" v-if="loading">
                <el-progress type="circle" :percentage="percentage"></el-progress>
            </div>
        </div>
        <div class="caption">说明：一次只能导入一个文件。</div>
        <div class="dia_btn_container">
            <el-button @click="cancel">取消</el-button>
            <el-button type="primary" @click="importFile">保存</el-button>
        </div>
    </div>
</template>
<script>
    let guid =  () => {
        let r
        let v
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            r = Math.random() * 16 | 0
            v = c === 'x' ? r : (r & 0x3 | 0x8)
            return v.toString(16)
        })
    }
    let dataURLtoBlob = dataurl => {
        let arr = dataurl.split(',')
        let mime = arr[0].match(/:(.*?);/)[1]
        let bstr = window.atob(arr[1])
        let n = bstr.length
        let u8arr = new Uint8Array(n)
        while (n--) {
            u8arr[n] = bstr.charCodeAt(n)
        }
        return new window.Blob([u8arr], { type: mime })
    }
    import Bus from '../../../bus/bus'
    import {API_ROOT} from '../../../config/index'
    export default {
        props: ['keyCode'],
        data: function(){
            return {
                loading: false,
                percentage: 0,
                fileName: '',
                fileCount: 0
            }
        },
        created: function() {
            this.init()
        },
        methods: {
            init() {
                this.fileName = ''
            },
            handleRemove() {
                this.fileCount--
            },
            handleBeforeUpload() {
                if (this.fileName) {
                    this.fileCount++
                    this.$message.warning('一次只能导入一个文件！')
                    return false
                }
            },
            httpRequestHandler(file) {
                this.uploadApi(file.file).then(data => {
                    this.loading = false
                    this.fileName = data.newFileName
                    this.fileCount++
                    this.percentage = 0
                }).catch(error => {
                    this.percentage = 0
                    this.loading = false
                    Log.error(error)
                })
            },
            // 文件上传接口 - 无响应
            uploadApi(file) {
                let _this = this
                _this.percentage = 0
                _this.loading = true
                if (!file) return
                let fileType = file.name.substring(file.name.lastIndexOf('.') + 1)
                // if (fileType !== 'xlsx') {
                //     _this.$message.error('该文件无法识别，上传文件支持格式为.xlsx')
                //     return Promise.reject('该文件无法识别，上传文件支持格式为.xlsx')
                // }
                return new Promise(function (resolve, reject) {
                    let uuid = guid()
                    let date = file.uid
                    let uploadtype = 'att'
                    let extend = '.' + file.name.substring(file.name.lastIndexOf('.') + 1)
                    let url = uuid + extend
                    let filename = file.name
                    let reader
                    let body
                    if (window.FileReader) {
                        reader = new window.FileReader()
                    }
                    reader.onloadend = function (e) {
                            body = e.target.result
                            let blob = dataURLtoBlob(body)
                            _this.$http({
                                method: 'post',
                                url: `/platserv/tenant/upload?filename=${url}&type=${uploadtype}&date=${date}`,
                                getBody: function () {
                                    return blob
                                },
                                headers: {
                                    'Content-Type': 'application/octet-stream'
                                },
                                progress(event) {
                                    _this.percentage = +(event.loaded / event.total * 100).toFixed(0)
                                    // if (_this.percentage === 100) {
                                    //     _this.percentage = 99
                                    // }
                                }
                            }).then((res) => {
                                resolve(res.data.resp_data)
                            }).catch((error) => {
                                _this.errorMessage(error)
                                reject(error)
                            })
                    }
                    // upload接口只接受二进制格式数据，但以下方法已经废除，需要查找
                    reader.readAsDataURL(file)
                })
            },
            importFile() {
                if (this.fileCount === 0) {
                    this.$message.warning('请先上传文件！')
                }
                this.$http.post(`/platserv/tenant/import`, {filename: this.fileName}).then(function(res) {
                    this.$message.success("导入成功！")
                    this.cancel()
                })
            },
            cancel() {
                this.$emit('cancelImportDia')
            },
            // 显示错误消息
            errorMessage(error) {
                let msg = (error.body && error.body.error_code) || error.statusText || error
                this.$message.error(msg)
            }
        }
    }
</script>


// WEBPACK FOOTER //
// Import.vue?08f418c1